import { useMemo } from 'react';
import { SchoolClassesConfig } from '../../../types/schoolConfigType';

const useClassOptions = (
  allClasses: SchoolClassesConfig | undefined,
  grade: string
): { gradeOptions: string[]; divisionOptions: string[] } => {
  const gradeOptions = useMemo(() => allClasses?.grades || [], [allClasses]);

  const divisionOptions = useMemo(() => {
    if (!allClasses) return [];
    if (grade) {
      return allClasses.classes
        .filter((cls) => cls.grade === grade)
        .map((cls) => cls.division);
    }
    return allClasses.divisions || [];
  }, [allClasses, grade]);

  return { gradeOptions, divisionOptions };
};

export default useClassOptions;
